/* Hover descriptions with verified, workspace-specific keyboard bindings. */
(()=>{'use strict';
  const model={moveMode:[['V']],rotateMode:[['R']],edgeMode:[['E']],smoothMode:[['S']],
    measureTool:[['M']],renderTool:[['P']],floor:[['W']],delete:[['D'],['Delete'],['Backspace']],
    copy:[['Ctrl','C']],paste:[['Ctrl','V']],duplicate:[['Ctrl','D']],fillSelection:[['F']],shortcuts:[['?']],
    workspaceRender:[['P']],cancelCurrentEdit:[['Esc']],
    stackTool:[['C','drag']]};
  const sketch={select:[['V']],copy:[['Ctrl','C']],paste:[['Ctrl','V']],duplicate:[['Ctrl','D']],
    delete:[['Delete'],['Backspace']],closeLoop:[['Enter']],cancel:[['Esc']]};
  const titles=new WeakMap(),tip=document.createElement('div'),description=document.createElement('div'),keys=document.createElement('div');
  tip.id='myerscadToolTip';tip.className='myerscad-tooltip';tip.hidden=true;tip.setAttribute('role','tooltip');
  description.className='tooltip-description';keys.className='tooltip-shortcuts';tip.append(description,keys);document.body.append(tip);
  let active=null,timer=0,enabled=window.MyersCADWorkspaceTools?.preferences().shortcutHints!==false,previousDescription=null;
  const platform=window.navigator?.userAgentData?.platform||window.navigator?.platform||'';
  const mac=/mac|iphone|ipad/i.test(platform);
  function binding(element){
    const declared=element.getAttribute('aria-keyshortcuts');
    if(declared)return declared.split(/\s+/).filter(Boolean).map(combo=>combo.split('+').map(key=>({Control:'Ctrl',Meta:'⌘',Escape:'Esc'}[key]||key)));
    const workspace=window.MyersCADWorkspaceToolsBridge?.state().workspace||'model';
    if(workspace==='physics')return [];
    const source=element.dataset.shortcutSource||element.id||'';
    if(['undo','redo'].includes(source))return source==='undo'?[['Ctrl','Z']]:[['Ctrl','Shift','Z']];
    const isSketch=workspace==='sketch';
    if(isSketch){
      const key=element.dataset.tool||element.dataset.action||source.replace(/^(tool|action):/,'');
      return sketch[key]||[];
    }
    if(workspace!=='model')return [];
    return model[source]||[];
  }
  function getDescription(element){return element.getAttribute('title')||titles.get(element)||element.getAttribute('aria-label')||'';}
  function position(){
    if(!active)return;
    const rect=active.getBoundingClientRect(),size=tip.getBoundingClientRect();
    const left=Math.max(8,Math.min(rect.left,window.innerWidth-size.width-8));
    const top=rect.bottom+8+size.height<=window.innerHeight?rect.bottom+8:Math.max(8,rect.top-size.height-8);
    tip.style.left=Math.round(left)+'px';tip.style.top=Math.round(top)+'px';
  }
  function render(){
    if(!active)return;
    if(!active.isConnected){hide();return;}
    const shortcuts=binding(active);let text=titles.get(active)||getDescription(active);
    // Existing inline hints move to the dedicated line, including when hints are hidden.
    if(shortcuts.length)text=text.replace(/\s*\((?:(?:Ctrl|Cmd|⌘|Shift|Alt|Delete|Backspace|Escape|Esc|Enter|Space)\+?\s*|[A-Z?])+\)\s*$/,'');
    description.textContent=text;keys.replaceChildren();keys.hidden=!enabled||!shortcuts.length;
    if(!keys.hidden){
      const label=document.createElement('span');label.className='tooltip-key-label';label.textContent='Shortcut';keys.append(label);
      shortcuts.forEach((combo,index)=>{
        if(index){const or=document.createElement('span');or.className='tooltip-or';or.textContent='or';keys.append(or);}
        combo.forEach((key,i)=>{
          if(i){const plus=document.createElement('span');plus.textContent='+';keys.append(plus);}
          const item=document.createElement(key==='drag'?'span':'kbd');item.textContent=key==='Ctrl'&&mac?'⌘':key;keys.append(item);
        });
      });
    }
    position();
  }
  const observer=new MutationObserver(()=>{
    if(!active)return;
    const updated=active.getAttribute('title');
    if(updated){titles.set(active,updated);active.removeAttribute('title');render();}
  });
  function hide(){
    clearTimeout(timer);timer=0;observer.disconnect();tip.hidden=true;
    if(active){
      if(!active.getAttribute('title')&&titles.has(active))active.setAttribute('title',titles.get(active));
      if(previousDescription===null)active.removeAttribute('aria-describedby');else active.setAttribute('aria-describedby',previousDescription);
    }
    active=null;previousDescription=null;
    if(tip.parentElement!==document.body)document.body.append(tip);
  }
  function show(element,immediate=false){
    if(element===active)return;
    hide();if(!element||!getDescription(element))return;
    active=element;const text=getDescription(element);titles.set(element,text);
    const dialog=element.closest('dialog');
    const host=dialog?.open?dialog:document.body;
    if(tip.parentElement!==host)host.append(tip);
    previousDescription=element.getAttribute('aria-describedby');
    element.setAttribute('aria-describedby',[previousDescription,tip.id].filter(Boolean).join(' '));
    element.removeAttribute('title');observer.observe(element,{attributes:true,attributeFilter:['title']});
    render();timer=setTimeout(()=>{timer=0;if(!active||!active.isConnected){hide();return;}tip.hidden=false;position();},immediate?0:420);
  }
  function target(event){return event.target.closest?.('button,summary,[title],[data-shortcut-source]');}
  document.addEventListener('pointerover',event=>{if(event.pointerType==='touch'||event.buttons)return;show(target(event));});
  document.addEventListener('pointerout',event=>{if(active&&!active.contains(event.relatedTarget))hide();});
  document.addEventListener('focusin',event=>{const element=target(event);if(element?.matches(':focus-visible'))show(element,true);});
  document.addEventListener('focusout',()=>hide());
  document.addEventListener('pointerdown',()=>hide(),true);
  document.addEventListener('keydown',()=>hide(),true);
  document.addEventListener('scroll',()=>hide(),true);
  document.addEventListener('close',()=>hide(),true);
  window.addEventListener('blur',()=>hide());window.addEventListener('resize',()=>hide());
  window.MyersCADTooltips={description:getDescription,binding,hide,setShortcutHints(value){enabled=value!==false;render();}};
})();
